// rg-reviews-tiers: reseñas propias de Judge.me (rediseño 2026-10-01). Dos usos:
//
//  A) Fichas de producto ([data-rg-tiers], bloque rg-resenas-escalonadas):
//       1. Resumen: puntaje y cantidad de reseñas del producto.
//       2. Franja "Así lo usan arqueros reales": fotos de las reseñas que las
//          traen, en loop automatico (como el home). Tocar una foto abre el visor.
//       3. Lista unica con filtros (Este producto / Otros colores /
//          Colección / Todas). En "Todas" el orden es: este producto, sus
//          colores, el resto de la coleccion. Todas las tarjetas tienen la MISMA
//          estructura, tengan foto o no.
//  B) Home ([data-rg-home-reviews], bloque rg-resenas-home): carrusel con
//     SOLO reseñas de 5 estrellas y con foto. Avanza solo hacia el costado,
//     se puede deslizar a mano y retoma solo al soltar.
//  C) Colecciones ([data-rg-fotos-strip], sección rg-fotos-clientes, 07-10):
//     la franja de fotos de A) con todas las fotos de los productos indicados.
//
// Usa el mismo endpoint publico que el carrusel nativo de Judge.me
// (carousels.js -> getReviews): {CDN_API_HOST}reviews/reviews_for_carousel.
// Es un endpoint no documentado: por eso todo esto es opcional. Si una
// consulta falla o no hay reseñas, no toca nada y queda visible el carrusel
// nativo de Judge.me. El nativo solo se oculta cuando todo salio bien.
//
// Limites verificados (2026-09-30): maximo 30 reseñas por consulta; dentro de
// una consulta mezcla productos; el parametro star_rating NO acepta "5"
// (devuelve 0) -- los filtros de estrellas y de foto se hacen aca, en el
// cliente, sobre las 30 que devuelve display_order=media_first.
(function () {
  var API = 'https://cdn.judge.me/reviews/reviews_for_carousel';
  // Dominio interno de Judge.me para esta tienda (el mismo que usa el bloque
  // nativo en su config; no es rawgoalie.myshopify.com).
  var SHOP_DOMAIN = 'e86ade-67.myshopify.com';
  var STORE_URL = 'https://rawgoalie.cl';

  // Solo reseñas de 4 y 5 estrellas en las fichas (pedido del usuario).
  var MIN_RATING = 4;
  // Lista de la ficha: cuantas tarjetas se ven al inicio y cuantas suma "Ver más".
  var INITIAL_COUNT = 3;
  var STEP = 5;
  // Franja de fotos: maximo de reseñas con foto.
  var STRIP_MAX = 14;
  var MARQUEE_SPEED = 45; // px por segundo (home)
  var RESUME_DELAY = 900; // ms sin tocar ni deslizar antes de retomar solo (home)

  function ids(str) {
    return (str || '').split(',').filter(Boolean);
  }

  function baseParams() {
    return new URLSearchParams({
      shop_domain: SHOP_DOMAIN,
      platform: 'shopify',
      url: STORE_URL,
      star_rating: 'all',
      carousel_type: 'cards',
      primary_language: 'es',
      display_order: 'media_first',
      max_reviews: '30'
    });
  }

  function request(q) {
    return fetch(API + '?' + q.toString())
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http')); })
      .then(function (d) { return d && Array.isArray(d.reviews) ? d.reviews : Promise.reject(new Error('formato')); });
  }

  function fetchAll() {
    var q = baseParams();
    q.set('reviews_selection', 'all');
    return request(q);
  }

  function fetchTier(productIds) {
    if (!productIds.length) return Promise.resolve([]);
    var q = baseParams();
    q.set('reviews_selection', 'custom_products');
    productIds.forEach(function (id) { q.append('product_ids[]', id); });
    return request(q);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function isHttps(u) {
    return typeof u === 'string' && u.indexOf('https://') === 0;
  }

  function shortName(r) {
    return String(r.product_title_localized || r.product_title || '').split('|')[0].trim();
  }

  // Judge.me entrega la ruta relativa (/products/...): sirve en el tema de prueba y en el real.
  function productHref(r) {
    var u = r.product_url;
    return typeof u === 'string' && u.indexOf('/products/') === 0 ? u : '';
  }

  function validPics(r, max) {
    return (r.pictures_urls || []).filter(function (p) {
      return p && isHttps(p.small) && isHttps(p.original);
    }).slice(0, max);
  }

  // Miniatura de ~420 px de ancho (las "small" miden 160 y se ven borrosas;
  // las "huge" miden 1024 y pesan de mas para una franja de 14 fotos).
  function tileSrc(p) {
    var u = isHttps(p.huge) ? p.huge : p.original;
    return u.replace(/width=\d+/, 'width=420');
  }

  function starsText(n) {
    n = Math.max(0, Math.min(5, parseInt(n, 10) || 0));
    return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  }

  function starsEl(n) {
    var s = el('div', 'rg-rv-stars', starsText(n));
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', (parseInt(n, 10) || 0) + ' de 5 estrellas');
    return s;
  }

  function dateText(r) {
    if (!r.created_at) return '';
    var d = new Date(r.created_at);
    return isNaN(d) ? '' : d.toLocaleDateString('es-CL', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  function authorRow(r) {
    var top = el('div', 'rg-rv-card__top');
    var name = r.reviewer_name || 'Cliente';
    top.appendChild(el('div', 'rg-rv-card__avatar', (r.reviewer_initial || name.charAt(0) || '?').charAt(0)));
    var who = el('div', 'rg-rv-card__who');
    who.appendChild(el('span', 'rg-rv-card__name', name));
    var dt = dateText(r);
    if (dt) who.appendChild(el('span', 'rg-rv-card__date', dt));
    top.appendChild(who);
    return top;
  }

  // ---------------------------------------------------------------- visor de fotos
  // Al tocar una foto de una reseña se abre AQUI MISMO, en pantalla completa
  // (nada de pestañas nuevas). Formas de volver: boton "Cerrar" grande, tocar
  // el fondo oscuro, tecla Esc, deslizar hacia abajo (celular) o el boton
  // "atras" del navegador/celular. Con varias fotos: flechas, teclado y
  // deslizar a los lados.
  // Zoom: en celular es el de siempre (pellizcar con dos dedos, tocar dos
  // veces, arrastrar para moverse). En escritorio, un clic amplia/reduce.
  var lb = null;
  var lbState = null;
  var MAX_ZOOM = 5;

  function isTouchDevice() {
    return (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
      (navigator.maxTouchPoints > 0 && window.innerWidth < 900);
  }

  function lbBuild() {
    var root = el('div', 'rg-lb');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Fotos de la reseña');
    root.hidden = true;

    var close = el('button', 'rg-lb__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Cerrar fotos y volver');
    close.appendChild(el('span', 'rg-lb__x', '✕'));
    close.appendChild(el('span', 'rg-lb__closetext', 'Cerrar'));

    var prev = el('button', 'rg-lb__nav rg-lb__nav--prev', '‹');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Foto anterior');
    var next = el('button', 'rg-lb__nav rg-lb__nav--next', '›');
    next.type = 'button';
    next.setAttribute('aria-label', 'Foto siguiente');

    var stage = el('div', 'rg-lb__stage');
    var img = el('img', 'rg-lb__img');
    img.alt = '';
    img.draggable = false;
    stage.appendChild(img);

    var bar = el('div', 'rg-lb__bar');
    var cap = el('div', 'rg-lb__cap');
    var count = el('div', 'rg-lb__count');
    var hint = el('div', 'rg-lb__hint');
    bar.appendChild(cap);
    bar.appendChild(count);
    bar.appendChild(hint);

    root.appendChild(close);
    root.appendChild(prev);
    root.appendChild(next);
    root.appendChild(stage);
    root.appendChild(bar);
    document.body.appendChild(root);

    var o = { root: root, img: img, stage: stage, cap: cap, count: count, prev: prev, next: next, close: close, hint: hint,
      scale: 1, tx: 0, ty: 0, touch: false };

    // Tocar el fondo oscuro (no la foto ni los botones) cierra.
    root.addEventListener('click', function (e) {
      if (e.target === root || e.target === stage || e.target === bar) lbClose();
    });
    close.addEventListener('click', lbClose);
    prev.addEventListener('click', function () { lbGo(-1); });
    next.addEventListener('click', function () { lbGo(1); });

    // Escritorio: un clic amplia / reduce (con scroll para moverse).
    img.addEventListener('click', function () {
      if (o.touch) return;
      root.classList.toggle('rg-lb--zoom');
      stage.scrollTop = 0;
      stage.scrollLeft = 0;
    });

    lbTouchGestures(o);

    document.addEventListener('keydown', function (e) {
      if (!lbState) return;
      if (e.key === 'Escape') { e.preventDefault(); lbClose(); }
      else if (e.key === 'ArrowLeft') lbGo(-1);
      else if (e.key === 'ArrowRight') lbGo(1);
      else if (e.key === 'Tab') {
        // el foco se queda dentro del visor
        var f = Array.prototype.filter.call(root.querySelectorAll('button'), function (b) { return !b.hidden && b.offsetParent !== null; });
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
    window.addEventListener('popstate', function () { if (lbState) lbCleanup(); });

    return o;
  }

  // ---- celular: pellizcar, doble toque, arrastrar, deslizar ----
  function lbTouchGestures(o) {
    var stage = o.stage;
    var img = o.img;
    var mode = null;        // 'pinch' | 'pan' | 'swipe' | null
    var p0 = null;          // datos de inicio del gesto
    var lastTap = { t: 0, x: 0, y: 0 };

    function setTransform(animated) {
      img.style.transition = animated ? 'transform 0.22s ease' : 'none';
      img.style.transform = 'translate3d(' + o.tx + 'px,' + o.ty + 'px,0) scale(' + o.scale + ')';
    }
    function clamp() {
      var sw = stage.clientWidth;
      var sh = stage.clientHeight;
      var w = img.offsetWidth * o.scale;
      var h = img.offsetHeight * o.scale;
      var mx = Math.max(0, (w - sw) / 2);
      var my = Math.max(0, (h - sh) / 2);
      o.tx = Math.max(-mx, Math.min(mx, o.tx));
      o.ty = Math.max(-my, Math.min(my, o.ty));
    }
    function center() {
      // centro del <img> SIN transformacion, en coordenadas de pantalla
      var r = img.getBoundingClientRect();
      return { x: r.left + r.width / 2 - o.tx, y: r.top + r.height / 2 - o.ty };
    }
    function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    function mid(a, b) { return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }; }

    o.resetZoom = function (animated) {
      o.scale = 1; o.tx = 0; o.ty = 0;
      setTransform(animated);
    };

    function zoomAt(px, py, s) {
      var c = center();
      var qx = px - c.x;
      var qy = py - c.y;
      o.scale = s;
      o.tx = qx * (1 - s);
      o.ty = qy * (1 - s);
      clamp();
      setTransform(true);
    }

    stage.addEventListener('touchstart', function (e) {
      if (!o.touch) return;
      var t = e.touches;
      if (t.length === 2) {
        var c = center();
        var m = mid(t[0], t[1]);
        mode = 'pinch';
        p0 = { d: dist(t[0], t[1]), s: o.scale, tx: o.tx, ty: o.ty, mx: m.x - c.x, my: m.y - c.y, cx: c.x, cy: c.y };
      } else if (t.length === 1) {
        mode = o.scale > 1.02 ? 'pan' : 'swipe';
        p0 = { x: t[0].clientX, y: t[0].clientY, tx: o.tx, ty: o.ty, time: Date.now(), moved: false };
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!o.touch || !mode) return;
      var t = e.touches;
      if (mode === 'pinch' && t.length === 2) {
        var d = dist(t[0], t[1]);
        var s = Math.max(1, Math.min(MAX_ZOOM, p0.s * d / p0.d));
        var m = mid(t[0], t[1]);
        var mx = m.x - p0.cx;
        var my = m.y - p0.cy;
        // el punto de la foto que estaba bajo los dedos sigue bajo los dedos
        var px = (p0.mx - p0.tx) / p0.s;
        var py = (p0.my - p0.ty) / p0.s;
        o.scale = s;
        o.tx = mx - px * s;
        o.ty = my - py * s;
        clamp();
        setTransform(false);
      } else if (mode === 'pan' && t.length === 1) {
        o.tx = p0.tx + (t[0].clientX - p0.x);
        o.ty = p0.ty + (t[0].clientY - p0.y);
        p0.moved = true;
        clamp();
        setTransform(false);
      } else if (mode === 'swipe' && t.length === 1) {
        if (Math.abs(t[0].clientX - p0.x) > 8 || Math.abs(t[0].clientY - p0.y) > 8) p0.moved = true;
      }
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!o.touch) return;
      var left = e.touches.length;
      if (mode === 'pinch') {
        if (o.scale < 1.05) o.resetZoom(true);
        // si queda un dedo apoyado, sigue como arrastre
        if (left === 1) {
          mode = 'pan';
          p0 = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: o.tx, ty: o.ty, time: Date.now(), moved: true };
        } else {
          mode = null;
        }
        return;
      }
      if (left > 0 || !e.changedTouches.length || !p0) return;
      var ct = e.changedTouches[0];
      var dx = ct.clientX - p0.x;
      var dy = ct.clientY - p0.y;
      var wasMode = mode;
      mode = null;

      // doble toque: amplia en ese punto / vuelve a tamaño normal
      var now = Date.now();
      var isTap = Math.abs(dx) < 10 && Math.abs(dy) < 10 && now - p0.time < 280;
      if (isTap && e.target === img) {
        if (now - lastTap.t < 320 && Math.hypot(ct.clientX - lastTap.x, ct.clientY - lastTap.y) < 40) {
          lastTap.t = 0;
          if (o.scale > 1.02) o.resetZoom(true); else zoomAt(ct.clientX, ct.clientY, 2.6);
          return;
        }
        lastTap = { t: now, x: ct.clientX, y: ct.clientY };
      }

      // sin zoom: deslizar abajo cierra, a los lados cambia de foto
      if (wasMode === 'swipe' && o.scale <= 1.02) {
        if (Math.abs(dy) > 90 && Math.abs(dy) > Math.abs(dx) * 1.5) lbClose();
        else if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) lbGo(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
    stage.addEventListener('touchcancel', function () { mode = null; }, { passive: true });
  }

  function lbRender() {
    var st = lbState;
    var p = st.photos[st.i];
    lb.root.classList.remove('rg-lb--zoom');
    lb.resetZoom(false);
    lb.stage.scrollTop = 0;
    lb.stage.scrollLeft = 0;
    lb.img.src = p;
    lb.img.alt = st.alt || 'Foto de la reseña';
    var multi = st.photos.length > 1;
    lb.prev.hidden = !multi;
    lb.next.hidden = !multi;
    lb.count.textContent = multi ? (st.i + 1) + ' / ' + st.photos.length : '';
    // pie: quien la escribio y lo que dijo (la foto puede abrirse desde la
    // franja, lejos de su texto)
    lb.cap.textContent = '';
    var c = st.caption || {};
    var l1 = el('div', 'rg-lb__who');
    l1.appendChild(el('span', 'rg-lb__stars', c.stars || ''));
    l1.appendChild(document.createTextNode(' ' + (c.name || '')));
    lb.cap.appendChild(l1);
    if (c.title) lb.cap.appendChild(el('div', 'rg-lb__title', c.title));
    if (c.body) lb.cap.appendChild(el('div', 'rg-lb__body', c.body));
    lb.hint.textContent = lb.touch
      ? 'Pellizca o toca dos veces para ampliar · desliza hacia abajo para volver'
      : 'Toca la foto para ampliar · toca fuera para volver';
  }

  function lbGo(d) {
    if (!lbState || lbState.photos.length < 2) return;
    lbState.i = (lbState.i + d + lbState.photos.length) % lbState.photos.length;
    lbRender();
  }

  function lbOpen(photos, index, caption, alt) {
    if (!photos.length) return;
    if (!lb) lb = lbBuild();
    lb.touch = isTouchDevice();
    lb.root.classList.toggle('rg-lb--touch', lb.touch);
    lbState = {
      photos: photos,
      i: index || 0,
      caption: caption,
      alt: alt,
      opener: document.activeElement,
      scrollY: window.pageYOffset,
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverflow: document.body.style.overflow
    };
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    lb.root.hidden = false;
    lbRender();
    lb.close.focus();
    // una entrada de historial: el boton "atras" cierra el visor en vez de
    // sacar a la persona de la pagina de producto
    try { history.pushState({ rgLightbox: true }, ''); lbState.pushed = true; } catch (err) { lbState.pushed = false; }
  }

  function lbCleanup() {
    if (!lbState) return;
    var st = lbState;
    lbState = null;
    lb.root.hidden = true;
    lb.img.removeAttribute('src');
    lb.resetZoom(false);
    document.documentElement.style.overflow = st.htmlOverflow;
    document.body.style.overflow = st.bodyOverflow;
    window.scrollTo(0, st.scrollY);
    if (st.opener && st.opener.focus) { try { st.opener.focus({ preventScroll: true }); } catch (err) { st.opener.focus(); } }
  }

  function lbClose() {
    if (!lbState) return;
    if (lbState.pushed && history.state && history.state.rgLightbox) {
      history.back(); // dispara popstate -> lbCleanup
    } else {
      lbCleanup();
    }
  }

  // Abre el visor para una reseña, en la foto `index`.
  function openReviewPhotos(r, index) {
    var all = validPics(r, 10);
    if (!all.length) return;
    var photos = all.map(function (p) { return isHttps(p.huge) ? p.huge : p.original; });
    lbOpen(photos, index || 0, {
      stars: starsText(r.rating),
      name: r.reviewer_name || 'Cliente',
      title: r.title || '',
      body: r.body || ''
    }, 'Foto de la reseña de ' + (r.reviewer_name || 'un cliente'));
  }

  // Convierte un <a> en disparador del visor (el href queda de respaldo).
  function wirePhoto(a, r, index) {
    a.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      openReviewPhotos(r, index);
    });
  }

  function hideNative() {
    var native = document.querySelector('.jdgm-cards-carousel');
    var block = native && native.closest('.shopify-block');
    if (block) block.hidden = true;
    // El boton "Mostrar mas" del carrusel nativo (rg-reviews-toggle.js) vive
    // dentro del mismo bloque, asi que se oculta junto con el.
  }

  // ================================================================== carrusel en loop
  // Carrusel con scroll REAL (dedo, trackpad, arrastre con mouse) al que se le
  // suma un avance automatico hacia el costado, en loop infinito. Cuando la
  // persona lo toca, el automatico se pausa y retoma solo RESUME_DELAY ms
  // despues de que suelta (y de que termina la inercia del dedo).
  // Lo usan el home y la franja de fotos de las fichas.
  //   makeSet(): devuelve elementos NUEVOS de un juego completo (se llama varias
  //              veces: el original y las copias del loop).
  //   minLoop:   con menos elementos que esto no hay loop (se queda quieto).
  function loopCarousel(scroller, track, makeSet, minLoop) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var setW = 0;         // ancho de UN juego completo
    var pos = 0;          // posicion del avance automatico (con decimales)
    var paused = false;
    var resumeTimer = null;
    var touching = false; // hay un dedo apoyado: nunca se reanuda por debajo de el
    var visible = true;
    var raf = 0;
    var last = 0;

    // Todos los juegos son identicos, asi que se puede saltar de uno a otro
    // sin que se note: se mantiene siempre dentro del juego central.
    function norm(p) {
      if (!setW) return p;
      while (p < setW) p += setW;
      while (p >= 2 * setW) p -= setW;
      return p;
    }

    function build() {
      track.textContent = '';
      var first = makeSet();
      first.forEach(function (n) { track.appendChild(n); });
      setW = track.scrollWidth;
      if (reduced || !setW || first.length < (minLoop || 1)) { setW = 0; return; }
      var copies = 3 + Math.ceil(scroller.clientWidth / setW);
      for (var i = 1; i < copies; i++) {
        makeSet().forEach(function (n) {
          n.setAttribute('aria-hidden', 'true');
          if (n.matches && n.matches('a,button')) n.tabIndex = -1;
          Array.prototype.forEach.call(n.querySelectorAll('a,button'), function (x) { x.tabIndex = -1; });
          track.appendChild(n);
        });
      }
      // arranca con un margen a la izquierda (el espacio entre tarjetas) para que
      // la primera tarjeta no quede pegada al borde
      pos = setW - (parseFloat(getComputedStyle(track.lastChild).marginRight) || 0);
      scroller.scrollLeft = pos;
    }

    function tick(ts) {
      raf = requestAnimationFrame(tick);
      var dt = last ? Math.min(ts - last, 64) / 1000 : 0;
      last = ts;
      if (paused || !visible || !setW) return;
      pos += MARQUEE_SPEED * dt;
      if (pos >= 2 * setW) pos -= setW;
      scroller.scrollLeft = pos;
    }
    function startLoop() { if (!raf && !reduced) { last = 0; raf = requestAnimationFrame(tick); } }
    function stopLoop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }

    // --- la persona toca / desliza: se pausa el automatico ---
    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
    }
    function scheduleResume() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        if (touching) { scheduleResume(); return; }
        if (setW) {
          var n = norm(scroller.scrollLeft);
          if (n !== scroller.scrollLeft) scroller.scrollLeft = n;
          pos = scroller.scrollLeft;
        }
        paused = false;
      }, RESUME_DELAY);
    }
    ['touchstart', 'pointerdown', 'wheel', 'focusin'].forEach(function (ev) {
      scroller.addEventListener(ev, function (e) {
        if (ev === 'touchstart') touching = true;
        pause();
        // la rueda no tiene "soltar": se programa la reanudacion de una vez
        if (ev === 'wheel') scheduleResume();
        if (ev === 'pointerdown' && e.pointerType === 'mouse') startMouseDrag(e);
      }, { passive: true });
    });
    ['touchend', 'touchcancel', 'pointerup', 'pointercancel', 'focusout'].forEach(function (ev) {
      scroller.addEventListener(ev, function (e) {
        if (ev === 'touchend' || ev === 'touchcancel') touching = !!(e.touches && e.touches.length);
        scheduleResume();
      }, { passive: true });
    });
    // El impulso del dedo sigue moviendo el scroll despues de soltar:
    // cada scroll mientras esta pausado reinicia la cuenta regresiva.
    scroller.addEventListener('scroll', function () {
      if (paused) scheduleResume();
    }, { passive: true });

    // --- arrastre con mouse (en escritorio no hay "deslizar" nativo) ---
    function startMouseDrag(e) {
      if (e.button !== 0) return;
      var startX = e.clientX;
      var startLeft = scroller.scrollLeft;
      var moved = false;
      scroller.classList.add('is-dragging');
      function move(ev) {
        var dx = ev.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        var p = startLeft - dx;
        var n = norm(p);
        startLeft += n - p;
        scroller.scrollLeft = n;
      }
      function up() {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', up);
        scroller.classList.remove('is-dragging');
        if (moved) {
          // que soltar despues de arrastrar no abra la foto/producto
          scroller.addEventListener('click', function (ce) {
            ce.preventDefault();
            ce.stopPropagation();
          }, { capture: true, once: true });
        }
        scheduleResume();
      }
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    }
    scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Solo anima cuando el carrusel esta en pantalla (ahorra bateria).
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) startLoop(); else stopLoop();
      }).observe(scroller);
    }

    build();
    startLoop();

    var lastWidth = window.innerWidth;
    var t = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(t);
      t = setTimeout(build, 250);
    });
  }

  // ================================================================== A) fichas
  // Tarjeta de la lista: MISMA estructura con o sin foto.
  //   [avatar · nombre / fecha ............ estrellas]
  //   titulo
  //   texto
  //   [etiqueta del producto] [Ver foto(s)] [verificada, si no lo son todas]
  function listCard(item, allVerified) {
    var r = item.r;
    var c = el('article', 'rg-rv-card rg-rv-card--list');

    var top = authorRow(r);
    top.appendChild(starsEl(r.rating));
    c.appendChild(top);

    if (r.title) c.appendChild(el('h4', 'rg-rv-card__title', r.title));
    if (r.body) c.appendChild(el('p', 'rg-rv-card__body', r.body));

    var foot = el('div', 'rg-rv-card__foot');
    if (item.showProduct && shortName(r)) {
      var chip;
      if (productHref(r)) {
        chip = el('a', 'rg-rv-chip', shortName(r));
        chip.href = productHref(r);
      } else {
        chip = el('span', 'rg-rv-chip', shortName(r));
      }
      chip.title = shortName(r);
      foot.appendChild(chip);
    }
    var n = validPics(r, 10).length;
    if (n) {
      var pb = el('button', 'rg-rv-photobtn');
      pb.type = 'button';
      pb.appendChild(el('span', 'rg-rv-photobtn__ico', '▣'));
      pb.appendChild(document.createTextNode(n > 1 ? 'Ver ' + n + ' fotos' : 'Ver foto'));
      pb.addEventListener('click', function () { openReviewPhotos(r, 0); });
      foot.appendChild(pb);
    }
    if (!allVerified && r.verified_buyer) foot.appendChild(el('span', 'rg-rv-verified', '✓ Compra verificada'));
    if (foot.childNodes.length) c.appendChild(foot);
    return c;
  }

  function readBadge() {
    // Puntaje y cantidad del producto: los entrega Judge.me en el HTML de la
    // pagina (insignia de estrellas junto al titulo).
    var b = document.querySelector('.jdgm-prev-badge');
    if (!b) return null;
    var avg = parseFloat(b.getAttribute('data-average-rating'));
    var n = parseInt(b.getAttribute('data-number-of-reviews'), 10);
    if (!(n > 0) || isNaN(avg)) return null;
    return { avg: avg, n: n };
  }

  function summaryEl(badge, allVerified) {
    var s = el('div', 'rg-sum');
    var avg = (Math.round(badge.avg * 10) / 10).toFixed(1).replace('.', ',');
    s.appendChild(el('div', 'rg-sum__score', avg));
    var mid = el('div', 'rg-sum__mid');
    var stars = el('div', 'rg-sum__stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', avg + ' de 5 estrellas');
    stars.appendChild(el('span', 'rg-sum__stars-bg', '★★★★★'));
    var fg = el('span', 'rg-sum__stars-fg', '★★★★★');
    fg.style.width = Math.max(0, Math.min(100, (badge.avg / 5) * 100)) + '%';
    stars.appendChild(fg);
    mid.appendChild(stars);
    mid.appendChild(el('div', 'rg-sum__count', 'Basado en ' + badge.n + (badge.n === 1 ? ' reseña' : ' reseñas') + ' de este producto'));
    s.appendChild(mid);
    if (allVerified) s.appendChild(el('div', 'rg-sum__ver', '✓ Todas de compradores verificados'));
    return s;
  }

  // Franja de fotos: mismo carrusel en loop automatico que el home. Se debe
  // llamar a wrap.rgInit() DESPUES de insertarla en la pagina (necesita medir).
  function stripEl(items) {
    var wrap = el('section', 'rg-strip');
    var head = el('div', 'rg-strip__head');
    head.appendChild(el('h3', 'rg-sec__title', 'Así lo usan arqueros reales'));
    wrap.appendChild(head);

    var scroller = el('div', 'rg-rv-marquee');
    scroller.setAttribute('role', 'region');
    scroller.setAttribute('aria-label', 'Fotos de reseñas de clientes');
    var track = el('div', 'rg-rv-track rg-strip__track');
    scroller.appendChild(track);
    wrap.appendChild(scroller);

    function makeSet() {
      return items.map(function (it) {
        var r = it.r;
        var pics = validPics(r, 10);
        var t = el('button', 'rg-tile');
        t.type = 'button';
        t.setAttribute('aria-label', 'Ver foto de ' + (r.reviewer_name || 'un cliente') + ', ' + (parseInt(r.rating, 10) || 0) + ' estrellas');
        var img = el('img');
        img.src = tileSrc(pics[0]);
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.draggable = false;
        t.appendChild(img);
        t.appendChild(starsEl(r.rating));
        if (pics.length > 1) t.appendChild(el('span', 'rg-tile__more', '+' + (pics.length - 1)));
        t.addEventListener('click', function () { openReviewPhotos(r, 0); });
        return t;
      });
    }
    // con menos de 4 fotos no hay loop (repetir 1-3 fotos se ve raro)
    wrap.rgInit = function () { loopCarousel(scroller, track, makeSet, 4); };
    return wrap;
  }

  // Arma el bloque de reseñas dentro de `root`.
  //   opts.badge:       {avg, n} -> muestra el resumen negro
  //   opts.note:        texto -> aviso arriba (reseñas de OTROS productos)
  //   opts.listTitle:   titulo de la lista
  function buildReviewsUI(root, items, opts) {
    // se muestra primero: la franja necesita medir su ancho para el loop
    root.hidden = false;

    // El sello "verificada" se dice UNA vez si todas las reseñas mostradas lo son;
    // si alguna no lo es, cada tarjeta indica si lo es.
    var allVerified = items.every(function (it) { return !!it.r.verified_buyer; });

    // 1) Resumen
    if (opts.badge) root.appendChild(summaryEl(opts.badge, allVerified));

    // aviso: son reseñas de otros productos
    if (opts.note) {
      var note = el('p', 'rg-note');
      note.appendChild(el('strong', null, opts.note.title));
      note.appendChild(el('span', null, ' ' + opts.note.text));
      root.appendChild(note);
    }

    // 2) Franja de fotos (en loop)
    var photoItems = items.filter(function (it) { return validPics(it.r, 1).length > 0; }).slice(0, STRIP_MAX);
    if (photoItems.length) {
      var strip = stripEl(photoItems);
      root.appendChild(strip);
      strip.rgInit();
    }

    // 3) Lista con filtros
    var section = el('section', 'rg-list-sec');
    var head = el('div', 'rg-list-head');
    head.appendChild(el('h3', 'rg-sec__title', opts.listTitle || 'Todas las reseñas'));
    var counts = {};
    TIERS.forEach(function (t) { counts[t.key] = items.filter(function (it) { return it.tier === t.key; }).length; });
    var activeTiers = TIERS.filter(function (t) { return counts[t.key] > 0; });
    var filter = 'all';
    var shown = INITIAL_COUNT;
    var chipEls = [];
    if (activeTiers.length > 1) {
      var chips = el('div', 'rg-chips');
      chips.setAttribute('role', 'group');
      chips.setAttribute('aria-label', 'Filtrar reseñas');
      // orden pedido: este producto, otros colores, colección y al final "Todas"
      activeTiers.map(function (t) {
        return { key: t.key, label: t.label, n: counts[t.key] };
      }).concat([{ key: 'all', label: 'Todas', n: items.length }]).forEach(function (c) {
        var b = el('button', 'rg-chipbtn', c.label + ' (' + c.n + ')');
        b.type = 'button';
        b.setAttribute('aria-pressed', c.key === 'all' ? 'true' : 'false');
        b.addEventListener('click', function () {
          filter = c.key;
          shown = INITIAL_COUNT;
          chipEls.forEach(function (x) { x.el.setAttribute('aria-pressed', x.key === filter ? 'true' : 'false'); });
          apply();
        });
        chipEls.push({ key: c.key, el: b });
        chips.appendChild(b);
      });
      head.appendChild(chips);
    }
    section.appendChild(head);

    var grid = el('div', 'rg-list');
    var cards = items.map(function (it) {
      var c = listCard(it, allVerified);
      grid.appendChild(c);
      return { el: c, tier: it.tier };
    });
    section.appendChild(grid);

    var actions = el('div', 'rg-tiers__actions');
    var btnLess = el('button', 'rg-tiers__more button button-secondary', 'Ver menos');
    btnLess.type = 'button';
    var btnMore = el('button', 'rg-tiers__more button button-secondary', 'Ver más');
    btnMore.type = 'button';
    actions.appendChild(btnLess);
    actions.appendChild(btnMore);
    section.appendChild(actions);

    function apply() {
      var idx = 0;
      cards.forEach(function (c) {
        if (filter !== 'all' && c.tier !== filter) { c.el.hidden = true; return; }
        c.el.hidden = idx >= shown;
        idx++;
      });
      var total = idx;
      // con INITIAL_COUNT reseñas o menos no hay botones
      actions.hidden = total <= INITIAL_COUNT;
      // "Ver menos" aparece apenas se abrio algo mas; "Ver más" desaparece
      // cuando ya se ven todas (ahi solo queda "Ver menos").
      btnLess.hidden = shown <= INITIAL_COUNT;
      btnMore.hidden = shown >= total;
    }
    btnLess.addEventListener('click', function () {
      shown = INITIAL_COUNT;
      apply();
      head.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    btnMore.addEventListener('click', function () {
      shown += STEP;
      apply();
    });
    apply();
    root.appendChild(section);
    hideNative();
  }

  var TIERS = [
    { key: 'own', label: 'Este producto', showProduct: false },
    { key: 'siblings', label: 'Otros colores', showProduct: true },
    { key: 'category', label: 'Colección', showProduct: true },
    { key: 'other', label: 'Otros productos', showProduct: true }
  ];

  // Respaldo: producto sin ninguna reseña de 4-5 estrellas (ni propias, ni de sus
  // colores, ni de su coleccion). Se muestran las mejores de 5 estrellas CON FOTO
  // de toda la tienda ("mejores" = las mas completas: con titulo y texto mas largo),
  // dejando claro que son de otros productos.
  function bestOfStore(reviews) {
    var seen = {};
    var pool = reviews.filter(function (r) {
      if (!r || !r.uuid || seen[r.uuid]) return false;
      seen[r.uuid] = true;
      return parseInt(r.rating, 10) === 5 && validPics(r, 1).length > 0;
    });
    function score(r) { return (r.title ? 40 : 0) + Math.min(String(r.body || '').length, 300); }
    pool.sort(function (a, b) { return score(b) - score(a); });
    return pool.slice(0, 12).map(function (r) { return { r: r, tier: 'other', showProduct: true }; });
  }

  function initTiers(root) {
    var own = ids(root.dataset.own);
    var siblings = ids(root.dataset.siblings).filter(function (id) {
      return own.indexOf(id) === -1;
    });
    var category = ids(root.dataset.category).filter(function (id, i, arr) {
      return arr.indexOf(id) === i && own.indexOf(id) === -1 && siblings.indexOf(id) === -1;
    });

    var ownKey = root.dataset.own;
    Promise.all([fetchTier(own), fetchTier(siblings), fetchTier(category)])
      .then(function (res) {
        // rg (08-10-2026): si mientras tanto la ficha cambió de producto (color en escritorio), esta respuesta ya no corresponde.
        if (root.dataset.own !== ownKey) return;
        var seen = {};
        var items = [];
        TIERS.slice(0, 3).forEach(function (t, ti) {
          var list = res[ti].filter(function (r) {
            if (!r || !r.uuid || seen[r.uuid]) return false;
            seen[r.uuid] = true;
            return (parseInt(r.rating, 10) || 0) >= MIN_RATING;
          });
          // Con foto primero (prioridad de visibilidad), luego solo texto.
          var withPhoto = list.filter(function (r) { return validPics(r, 1).length > 0; });
          var textOnly = list.filter(function (r) { return validPics(r, 1).length === 0; });
          withPhoto.concat(textOnly).forEach(function (r) {
            items.push({ r: r, tier: t.key, showProduct: t.showProduct });
          });
        });

        if (items.length) {
          buildReviewsUI(root, items, { badge: readBadge() });
          return;
        }
        // Sin reseñas: respaldo con las mejores de otros productos
        return fetchAll().then(function (all) {
          var fallback = bestOfStore(all);
          if (!fallback.length) return;
          buildReviewsUI(root, fallback, {
            note: {
              title: 'Este producto todavía no tiene reseñas.',
              text: 'Mira lo que dicen quienes compraron otros productos de Raw Goalie y Radon.'
            },
            listTitle: 'Reseñas de otros productos'
          });
          // rg (2026-10-02): la pildora nativa de Judge.me junto al titulo
          // (".jdgm-prev-badge", puntaje sin filtrar) se oculta ahora de
          // forma global para cualquier producto bajo MIN_RATING -- ver
          // assets/rg-hide-low-badges.js (cargado en layout/theme.liquid).
          // No hace falta repetir la logica aca.
        });
      })
      .catch(function (err) { if (window.console) console.warn('rg-reviews: queda el carrusel nativo', err); });
  }

  // ================================================================== B) home
  // Tarjeta del carrusel del home: foto 4:5 arriba, titulo, texto corto y una
  // fila final con el autor (compra verificada) y el enlace "Ver producto".
  function homeCard(r) {
    var pics = validPics(r, 1);
    var c = el('article', 'rg-rv-card rg-rv-card--home');

    var hero = el('a', 'rg-rv-card__hero');
    hero.href = pics[0].original;
    hero.rel = 'noopener';
    hero.setAttribute('aria-label', 'Ver foto de la reseña de ' + (r.reviewer_name || 'un cliente') + ' en grande');
    wirePhoto(hero, r, 0);
    var himg = el('img');
    himg.src = isHttps(pics[0].huge) ? pics[0].huge : pics[0].small;
    himg.alt = 'Foto de la reseña de ' + (r.reviewer_name || 'un cliente');
    himg.loading = 'lazy';
    himg.decoding = 'async';
    himg.draggable = false;
    hero.appendChild(himg);
    hero.appendChild(starsEl(r.rating));
    c.appendChild(hero);

    var body = el('div', 'rg-rv-card__content');
    if (r.title) body.appendChild(el('h4', 'rg-rv-card__title', r.title));
    if (r.body) body.appendChild(el('p', 'rg-rv-card__body', r.body));

    var foot = el('div', 'rg-rv-card__foot rg-rv-card__foot--home');
    var name = r.reviewer_name || 'Cliente';
    foot.appendChild(el('span', 'rg-rv-card__name', name));
    var row = el('div', 'rg-rv-card__row');
    row.appendChild(el('span', 'rg-rv-card__date', r.verified_buyer ? '✓ Verificada' : ''));
    if (productHref(r)) {
      var go = el('a', 'rg-rv-go', 'Ver producto');
      go.href = productHref(r);
      if (shortName(r)) go.title = shortName(r);
      go.setAttribute('aria-label', 'Ver producto: ' + (shortName(r) || 'producto de esta reseña'));
      row.appendChild(go);
    }
    foot.appendChild(row);
    body.appendChild(foot);
    c.appendChild(body);
    return c;
  }

  // Puntaje y cantidad de la tienda: Judge.me los deja en el script del carrusel
  // nativo (averageRating / reviewCount). Si cambian de lugar, se omiten sin
  // romper nada (el subtitulo queda solo con texto).
  function readStoreStats() {
    var scripts = document.scripts;
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent;
      if (!t || t.indexOf('averageRating') === -1) continue;
      var a = /averageRating\s*=\s*([\d.]+)/.exec(t);
      var n = /reviewCount\s*:\s*(\d+)/.exec(t);
      if (a && n && parseFloat(a[1]) > 0 && parseInt(n[1], 10) > 0) {
        return { avg: parseFloat(a[1]), n: parseInt(n[1], 10) };
      }
    }
    return null;
  }

  function initHome(root) {
    var title = root.dataset.title || '¿Qué opinan los clientes?';
    var sub = root.dataset.subtitle || '';

    fetchAll()
      .then(function (reviews) {
        var seen = {};
        var list = reviews.filter(function (r) {
          if (!r || !r.uuid || seen[r.uuid]) return false;
          seen[r.uuid] = true;
          return parseInt(r.rating, 10) === 5 && validPics(r, 1).length > 0;
        });
        if (!list.length) return;

        root.appendChild(el('h2', 'rg-rv-home__title', title));

        // Prueba social destacada: puntaje grande + estrellas + cantidad
        var stats = readStoreStats();
        if (stats) {
          var avg = (Math.round(stats.avg * 10) / 10).toFixed(1).replace('.', ',');
          var proof = el('div', 'rg-rv-proof');
          proof.setAttribute('role', 'img');
          proof.setAttribute('aria-label', avg + ' de 5 estrellas, ' + stats.n + ' reseñas de arqueros y clientes reales');
          proof.appendChild(el('span', 'rg-rv-proof__score', avg));
          var pst = el('span', 'rg-rv-proof__stars');
          pst.appendChild(el('span', 'rg-rv-proof__stars-bg', '★★★★★'));
          var pfg = el('span', 'rg-rv-proof__stars-fg', '★★★★★');
          pfg.style.width = Math.max(0, Math.min(100, (stats.avg / 5) * 100)) + '%';
          pst.appendChild(pfg);
          proof.appendChild(pst);
          var ptx = el('span', 'rg-rv-proof__text');
          ptx.appendChild(el('strong', null, stats.n + ' reseñas'));
          ptx.appendChild(document.createTextNode(' de arqueros y clientes reales'));
          proof.appendChild(ptx);
          root.appendChild(proof);
        } else if (sub) {
          root.appendChild(el('p', 'rg-rv-home__sub', sub));
        }

        var scroller = el('div', 'rg-rv-marquee');
        scroller.setAttribute('role', 'region');
        scroller.setAttribute('aria-label', 'Reseñas de clientes con foto');
        var track = el('div', 'rg-rv-track');
        scroller.appendChild(track);
        root.appendChild(scroller);
        root.hidden = false;

        loopCarousel(scroller, track, function () { return list.map(homeCard); }, 1);
        hideNative();
      })
      .catch(function (err) { if (window.console) console.warn('rg-reviews: queda el carrusel nativo', err); });
  }

  // ================================================================== C) colecciones
  // Franja de fotos de clientes en una colección ([data-rg-fotos-strip], sections/rg-fotos-clientes):
  // la MISMA franja en loop de las fichas, con TODAS las reseñas de 4-5 estrellas con foto de los
  // productos de data-ids. Se pide de a un producto (el endpoint corta en 30 por consulta). El título
  // lo pone la sección (respeta el color del fondo), por eso se quita el de la franja.
  function initFotosStrip(root) {
    var list = ids(root.dataset.ids);
    if (!list.length) return;
    Promise.all(list.map(function (id) {
      return fetchTier([id]).catch(function () { return []; });
    }))
      .then(function (res) {
        var seen = {};
        var items = [];
        res.forEach(function (reviews) {
          reviews.forEach(function (r) {
            if (!r || !r.uuid || seen[r.uuid]) return;
            seen[r.uuid] = true;
            if ((parseInt(r.rating, 10) || 0) >= MIN_RATING && validPics(r, 1).length) items.push({ r: r });
          });
        });
        if (!items.length) return;
        items.sort(function (a, b) { return String(b.r.created_at || '').localeCompare(String(a.r.created_at || '')); });
        var strip = stripEl(items);
        var head = strip.querySelector('.rg-strip__head');
        if (head) head.remove();
        root.appendChild(strip);
        root.hidden = false;
        var box = root.closest('[data-rg-fc]');
        if (box) box.hidden = false;
        strip.rgInit();
      })
      .catch(function (err) { if (window.console) console.warn('rg-reviews: sin fotos de clientes', err); });
  }

  function start() {
    document.querySelectorAll('[data-rg-fotos-strip]').forEach(function (n) {
      if (n.dataset.rgFotosStarted) return;
      n.dataset.rgFotosStarted = 'true';
      initFotosStrip(n);
    });
    var tiers = document.querySelector('[data-rg-tiers]');
    if (tiers && !tiers.dataset.rgTiersStarted) {
      tiers.dataset.rgTiersStarted = 'true';
      initTiers(tiers);
    }
    var home = document.querySelector('[data-rg-home-reviews]');
    if (home && !home.dataset.rgHomeStarted) {
      home.dataset.rgHomeStarted = 'true';
      initHome(home);
    }
  }

  // rg (bug-check 08-10-2026, I4): al cambiar de color en escritorio el tema reemplaza el contenido de la ficha (morph) y la
  // sección de reseñas vuelve vacía y oculta, sin que este script corra de nuevo. Con el observador compartido de cambios del
  // DOM se vuelve a llamar start(): solo arma lo que quedó sin armar (marca data-rg-*-started), así que no repite trabajo.
  function vigilar() {
    var pendiente = false;
    var revisar = function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; start(); });
    };
    if (!window.__rgObservarCambiosDom) {
      window.__rgDomWatchers = [];
      window.__rgObservarCambiosDom = function (fn) { window.__rgDomWatchers.push(fn); };
      new MutationObserver(function (mutaciones) {
        window.__rgDomWatchers.forEach(function (fn) { fn(mutaciones); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.__rgObservarCambiosDom(revisar);
  }

  function arrancar() { start(); vigilar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
